import gql from 'graphql-tag';

const GET_RULEBUILDER_OPERATORS = gql`
  query {
    getRuleBuilderOperators
  }
`;

const GET_ENTITY_PROPERTIES = gql`
  query {
    getEntitiesMeta(
      entityNames: [
        "Technician"
        "Ticket"
        "User"
        "TechnicianGroup"
        "Requester"
        "Approval"
        "Task"
        "Client"
        "Project"
        "Site"
        "SLA"
        "Employee"
        "ClientUser"
        "Designation"
        "BusinessFunction"
        "Team"
        "Role"
        "Inviter"
        "Alert"
        "Asset"
        "Policy"
        "AssetCPUMemData"
        "AssetScript"
        "AssetSoftwareInventory"
        "NMAsset"
        "PolicyCategory"
        "AllAssets"
        "PrimaryContact"
        "SecondaryContact"
        "ReportingManager"
        "AccountManager"
        "AssetSoftware"
        "OutgoingMailSettings"
        "Chart"
        "Report"
        "Worklog"
        "OfferedItem"
        "ServiceItem"
        "ServiceCatalogItem"
        "ServiceTypeItem"
        "Invoice"
        "Quote"
        "WorkStation"
        "PatchDetail"
        "CurrentApproval"
        "CurrentNote"
        "CurrentReply"
        "ProjectOwner"
        "PatchKb"
        "RequesterAssociation"
        "Account"
        "AssetClass"
        "AssetPatchDetail"
        "CommunityScript"
        "PatchHealth"
        "AntiVirusHealth"
        "DataBackupHealth"
        "Email"
        "WorkItem"
        "Printer"
        "IPAsset"
        "AssetMake"
        "AssetModel"
        "HoursWorklogEntry"
        "HoursServiceItem"
        "Firewall"
        "Router"
        "Switch"
        "IPCamera"
        "LoadBalancer"
        "PowerDistributionUnit"
        "Storage"
        "UPS"
        "VOIP"
        "WANAccelerator"
        "WirelessAccessPoint"
        "WirelessLANController"
        "NAS"
        "FeedbackSurvey"
        "FeedbackSurveyResponse"
        "ServerHardwareController"
        "AssetRemoteSession"
        "ConversationThread"
        "Conversation"
        "ConversationThreadRecipient"
        "MacAssetUdfValues"
        "LinuxAssetUdfValues"
        "WindowsAsset"
        "ContractApplicationRuleCondition"
        "ProvisionRule"
        "UserOrgAssociation"
        "BarcodePrinter"
        "PaymentMethod"
        "PaymentTerm"
        "GlobalPatchDetail"
        "Android"
        "AppleIOS"
        "AppleIPadOS"
        "FilteredAssetSoftwareInventory"
      ]
    ) {
      label
      name
      # reportEnabled
      attributes {
        name
        label
        attributePlaceHolder {
          key
          label
        }
        filterType
        isIdentifier
        isKeyAttribute
        dataType
        entity
        uiDataType
        conditionPlaceHolders {
          key
          label
        }
        isCustom
        isDependent
        nestedAttributes
        nestedTo
        showToClient
        autoComplete
        useInMetric
        metricFunctions
        metricUnits
        labelInMetric
        useInGroupBy
        useInCondition
        conditionPlaceHoldersMeta
      }
    }
  }
`;

const GET_ENTITY_NAMES_META = gql`
  query getEntitiesMeta($entitiesName: [String]) {
    getEntitiesMeta(entityNames: $entitiesName) {
      label
      name
      attributes {
        name
        label
        attributePlaceHolder {
          key
          label
        }
        filterType
        isIdentifier
        isKeyAttribute
        isDependent
        dataType
        entity
        uiDataType
        conditionPlaceHolders {
          key
          label
        }
        isCustom
        nestedAttributes
        nestedTo
        showToClient
        autoComplete
        useInMetric
        metricFunctions
        metricUnits
        labelInMetric
        useInGroupBy
        useInCondition
        conditionPlaceHoldersMeta
      }
    }
  }
`;

export {
  GET_RULEBUILDER_OPERATORS,
  GET_ENTITY_PROPERTIES,
  GET_ENTITY_NAMES_META
};
